/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserFavoriteStationsList } from '../../models/user-favorite-stations-list';
import { UserSearch } from '../../models/user-search';

export interface SearchUsersFavoriteStations$Params {

/**
 * The search text to filter API
 */
  search?: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  
    /**
     * Body for search contacts
     */
    body?: UserSearch
}

export function searchUsersFavoriteStations(http: HttpClient, rootUrl: string, params?: SearchUsersFavoriteStations$Params, context?: HttpContext): Observable<StrictHttpResponse<UserFavoriteStationsList>> {
  const rb = new RequestBuilder(rootUrl, searchUsersFavoriteStations.PATH, 'post');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserFavoriteStationsList>;
    })
  );
}

searchUsersFavoriteStations.PATH = '/users/favorite-stations/search';
